import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Slides } from 'ionic-angular';
import { WalletCard } from '../../model/models/wallet/wallet';
import { WalletCardProvider } from '../../providers/wallet/wallet-card';
import { TranslateService } from '@ngx-translate/core';
import { CARDTYPE } from '../../model/models/wallet/wallet-card';
@Component({
  selector: 'rmt-wallet-cards',
  templateUrl: 'rmt-wallet-cards.html'
})
export class RmtWalletCardsComponent {
  @ViewChild(Slides) slides: Slides;
  @Input()spaceBetween:any;
  @Input()slidesPerView:any;
  @Input() cardsData: any;
  @Input() selectedCardData: WalletCard;
  @Output() onCardSlideChangeEvent = new EventEmitter();
  @Output() onCardDetailsClickEvent = new EventEmitter();
  @Output() onSlideReachEnd = new EventEmitter();
  @Output() onSlideReachStart = new EventEmitter();
  slidesReady = false;

  cardNumber: string;
  detailsButtonText: string
  selectedCard:WalletCard;
  private detailsVisible = false;
  constructor(private walletCardProvider: WalletCardProvider, private translate: TranslateService) {
    this.selectedCard = new WalletCard();
  }
  
  ngAfterViewInit() {
    this.cardNumber = this.walletCardProvider.getLastFourDigitsofCard(this.selectedCard, true, false)

    setTimeout(() => {
    if (this.slides && (this.slides as any).update) {
      (this.slides as any).update(); // trigger a re-measurement
    }
    this.slidesReady = true; // reveal only when stable
  }, 250); // 100–200 ms is usually enough

  }
  
  ngOnInit(){
    let currentCardIndex = 0;
    if(this.selectedCardData && this.cardsData.length > 1 && this.selectedCardData.CardType === CARDTYPE.VIRTUAL_CARD){
      currentCardIndex = 1;
      setTimeout(() => {
        this.slides.slideTo(currentCardIndex);  
      }, 500);
    }
    this.setSelectedCard(currentCardIndex);
    if(this.cardsData.length <= 1){
      this.slides.lockSwipes(true);
    }
  }

  ngDoCheck(){
    // Fix for snapping out of the slider container to blank canvas
    const detailsVisible = !!(this.selectedCard && this.selectedCard.CanShowDetails);
    if(detailsVisible !== this.detailsVisible){
      this.detailsVisible = detailsVisible;
      this.refreshSlides();
    }
  }

  refreshSlides(){
    if(!this.slides){
      return;
    }
    this.slides.update();
    setTimeout(() => {
      if(this.slides){
        this.slides.slideTo(Math.min(this.slides.getActiveIndex(), this.cardsData.length - 1), 0, false);
      }
    }, 350);
  }

  onCardSlideChange(){
    // With fractional slidesPerView, over-swiping can report an index past the last card; ignore it so we never emit undefined
    const currentSlideIndex = this.slides.getActiveIndex();
    if (currentSlideIndex < 0 || currentSlideIndex >= this.cardsData.length) return;
    this.setSelectedCard(currentSlideIndex);
  }

  setSelectedCard(index){
    this.selectedCard = this.cardsData[index];
    this.cardNumber = this.walletCardProvider.getLastFourDigitsofCard(this.selectedCard, true, false)
    if(this.onCardSlideChangeEvent){
      this.onCardSlideChangeEvent.emit(this.selectedCard);
    }
  }

  onShowOrHideDetailsClick(){
    if(this.onCardDetailsClickEvent){
      this.onCardDetailsClickEvent.emit(this.selectedCard);
    }
  }

  getDetailsButtonText(card){
    if(!card.CanShowDetails){
      return this.translate.instant('page.eWalletPage.prepaidCardActivityPage.seeDetailsTitle');
    } else {
      return this.translate.instant('page.eWalletPage.prepaidCardActivityPage.hideDetailsTitle');
    }
  }
  onSlideReachEndEmit(event){
    if(this.onSlideReachEnd && this.cardsData.length > 1)
      this.onSlideReachEnd.emit(event);
  }
  onSlideReachStartEmit(event){
    if(this.onSlideReachStart && this.cardsData.length > 1)
      this.onSlideReachStart.emit(event);
  }
 
}



// WEBPACK FOOTER //
// ./src/components/rmt-wallet-cards/rmt-wallet-cards.ts